import { styled } from '@mui/material/styles';
import { ReactComponent as InfoIcn } from './../../assets/info.svg';

export const InfoIcon = styled(InfoIcn)(({ theme }) => ({
  height: '20px',
  width: '20px',
  marginTop: '20px'
}));
